import * as z from "zod";

import { organizationWithContactSchema } from "./organization-with-contact";

export const procurementOrganizationSchema = z.object({
  organization: organizationWithContactSchema,
  price: z.number().optional(),
});

export type ProcurementOrganization = z.infer<
  typeof procurementOrganizationSchema
>;
